import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Typography,
  Modal,
  Form,
  Select,
  message,
  Row,
  Col,
} from "antd";
import "./Styles/Dashboard.css";
import OrderDetailsModal from "./OrderDetailsModal"; // Import the OrderDetailsModal component
import moment from "moment"; // Import Moment library for date formatting

const { Link } = Typography;
const { Option } = Select;
const { confirm } = Modal; // Import Modal.confirm

const Dashboard = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrder2, setSelectedOrder2] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [form] = Form.useForm();
  const [orderData, setOrderData] = useState([]);
  const [staffData, setStaffData] = useState([]);

  useEffect(() => {
    const VendorId = localStorage.getItem("vendor_id");
    setVendorId(VendorId);
    fetchShipmentOrders(VendorId);
  }, [refreshTrigger]);

  const fetchShipmentOrders = async (VendorId) => {
    try {
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/readytoship_orders",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vendor_id: VendorId }),
        }
      );
      if (!response.ok) {
        setOrderData([]);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched shipment orders:", data);
      setOrderData(data);
    } catch (error) {
      console.error("Error fetching shipment orders:", error.message);
      // You might want to set some error state here to display to the user
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Order Id",
      dataIndex: "order_id",
      key: "orderId",
      render: (text) => (
        <Link onClick={() => handleOrderDetails(text)}>{text}</Link>
      ),
    },
    {
      title: "Date & Time",
      dataIndex: "order_date",
      key: "order_date",
      render: (text) => formatDate(text), // Render using custom format function
    },
    {
      title: "Packed Date & Time",
      dataIndex: "order_date",
      key: "order_date",
      render: (text) => formatDate(text), // Render using custom format function
    },
    {
      title: "Shiped Date & Time",
      dataIndex: "order_date",
      key: "order_date",
      render: (text) => formatDate(text), // Render using custom format function
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text, record) =>
        `${record.shipping_first_name} ${record.shipping_last_name}`,
    },
    {
      title: "Customer Phone",
      dataIndex: "customer_phone",
      key: "customer_phone",
    },
    {
      title: "Invoice",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => showAssignModal2(record)}>
          Invoice
        </Button>
      ),
    },
    {
      title: "E-Com Label",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => generateLabel(record)}>
          Label
        </Button>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Row gutter={8}>
          <Col span={12}>
            <Button
              type="primary"
              danger
              onClick={() => showAssignModal3(record)}
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" onClick={() => showAssignModal4(record)}>
              Pickup
            </Button>
          </Col>
        </Row>
      ),
    },
  ];

  const generateLabel = async (record) => {
    try {
      // Call the API to request PDF generation
      const response = await fetch(
        "https://app-tl2d3sc25q-uc.a.run.app/api/get_shipping_label",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ orderId: record.order_id, vendorId }), // Send order_id to API
        }
      );

      if (!response.ok) {
        throw new Error("Failed to request PDF generation");
      }

      // Convert the response to a blob (binary data)
      const blob = await response.blob();

      // Create a URL for the blob and open it
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      message.success("PDF generated successfully");
    } catch (error) {
      console.error("Error generating PDF:", error);
      message.error("Error generating PDF");
    }
  };

  const showAssignModal3 = (record) => {
    confirm({
      title: "Are you sure you want to Cancel this order?",
      content: `Order ID: ${record.order_id}`,
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      onOk: () => cancelOrder(record),
    });
  };

  const showAssignModal4 = (record) => {
    confirm({
      title: "Are you sure you want to Pickup this order?",
      content: `Order ID: ${record.order_id}`,
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      onOk: () => Pickup(record),
    });
  };

  const Pickup = async (record) => {
    console.log(record);
    try {
      let data = {
        order_id: record.order_id,
        vendor_id: vendorId,
      };
      const response = await fetch(`https://app-tl2d3sc25q-uc.a.run.app/api/move_pickedup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error("Failed to cancel order");
      }
      message.success("Order Pickup successfully");
      setRefreshTrigger((prev) => prev + 1); // Refresh the orders list
    } catch (error) {
      console.error("Error cancelling order:", error);
      message.error("Failed to cancel order");
    }
  };

  const cancelOrder = async (record) => {
    console.log(record);
    try {
      let data = {
        order_id: record.order_id,
        vendor_id: vendorId,
        awb_number: record.awb,
      };
      const response = await fetch(`https://app-tl2d3sc25q-uc.a.run.app/api/cancel_order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error("Failed to cancel order");
      }
      message.success("Order cancelled successfully");
      setRefreshTrigger((prev) => prev + 1); // Refresh the orders list
    } catch (error) {
      console.error("Error cancelling order:", error);
      message.error("Failed to cancel order");
    }
  };

  const formatDate = (dateString) => {
    console.log("come");
    // Use Moment.js or JavaScript Date object to format the date
    const formattedDate = moment(dateString).format("DD:MM:YYYY hh:mm A");
    return formattedDate;
  };

  const showAssignModal2 = (record) => {
    console.log("Comeeee");
    setSelectedOrder2(record);
    setIsModalVisible2(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  const handleCancel2 = () => {
    setIsModalVisible2(false);
    form.resetFields();
  };

  const handleOk2 = () => {
    form
      .validateFields()
      .then((values) => {
        const selectedStaff = staffData.find(
          (staff) => staff.id === values.staffId
        );
        assignStaffToOrder(
          values.staffId,
          selectedStaff.name,
          selectedOrder2.customer_name,
          selectedOrder2.customer_phone,
          selectedOrder2.order_id
        );
        setIsModalVisible2(false);
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const assignStaffToOrder = async (
    staffId,
    staffName,
    customerName,
    customerPhone,
    orderId
  ) => {
    try {
      const response = await fetch(
        `https://app-nm5xb3nmya-uc.a.run.app/api/assign_accountant`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            roll_acct: staffId,
            order_id: orderId,
            accountant_name: staffName,
            customer_name: customerName,
            customer_phone: customerPhone,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to assign staff to order");
      }
      message.success("Staff assigned successfully");

      // Optionally, you can update the orderData state after assignment if needed
    } catch (error) {
      console.error("Error assigning staff to order:", error);
    }
  };

  const handleOrderDetails = async (orderId) => {
    console.log(vendorId);
    try {
      const response = await fetch("https://app-tl2d3sc25q-uc.a.run.app/api/order_details", {
        method: "POST", // Use POST if you are sending data in the body
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          vendorId,
          orderId,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch order details");
      }
      const data = await response.json();
      console.log("Order Details:", data);
      // Display modal with order details
      setSelectedOrder(data); // Store order details in state
      setIsModalVisible(true); // Show modal
    } catch (error) {
      console.error("Error fetching order details:", error);
      // Handle error state if needed
    }
  };

  return (
    <div className="dashboard-container">
      <Table
        columns={columns}
        dataSource={orderData}
        rowKey="id"
        scroll={{ x: 1900, y: 500 }}
      />

      <OrderDetailsModal
        visible={isModalVisible}
        order={selectedOrder}
        staffData={staffData}
        onCancel={handleCancel}
      />

      <Modal
        title="Assign Order"
        visible={isModalVisible2}
        onOk={handleOk2}
        onCancel={handleCancel2}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="staffId"
            label="Select Staff"
            rules={[
              { required: true, message: "Please select a staff member" },
            ]}
          >
            <Select placeholder="Select a staff member">
              {staffData.map((staff) => (
                <Option key={staff.id} value={staff.id}>
                  {staff.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Dashboard;
